import { combineReducers } from "redux";
import PendingFarms from "./NewFarms";

const DashboardReducers = combineReducers({
  PendingFarms: PendingFarms,
});

export default DashboardReducers;
